export class UtilsObjects {
  static deleteNullProps(obj) {
    //Object.keys(obj).forEach((key) => (obj[key] == null) && delete obj[key]); 
    for (var prop in obj) {
      if (obj[prop] === null || obj[prop] === undefined || (Array.isArray(obj[prop]) && !obj[prop].length)) {
        delete obj[prop];
      }
    }
  }
}
